export const englishValidationMessages = {
    fieldNames: {
        name: 'Name',
        title: 'Name',
        streetName: 'Street name',
        cityName: 'City name',
        postalCode: 'Postal code',
        companyName: 'Company name',
        phoneNumber: 'Phone number',
        invoicePrefix: 'Invoice prefix'
    },
    tooShort: (param)=>{
        let { field, min } = param;
        return "".concat(field, " must be at least ").concat(min, " characters");
    },
    tooLong: (param)=>{
        let { field, max } = param;
        return "".concat(field, " can be up to ").concat(max, " characters");
    },
    htmlCharacters: (param)=>{
        let { field } = param;
        return "".concat(field ? "".concat(field, " may") : 'May', " include only these special characters: _%+:;#()[]$*&,.'-");
    },
    streetCharacters: (param)=>{
        let { field } = param;
        return "".concat(field, " may include only these special characters: ,.()#'-");
    },
    nameCharacters: (param)=>{
        let { field } = param;
        return "".concat(field, " may not contain: =<>");
    },
    poBox: ()=>'PO boxes are not allowed',
    invalid: (param)=>{
        let { field } = param;
        return "".concat(field, " is invalid");
    },
    invalidEmail: ()=>'Please enter a valid email address',
    invalidUsPhone: ()=>'invalid US phone number',
    mustContainLetter: (param)=>{
        let { field } = param;
        return "".concat(field, " must contain at least one letter");
    },
    invoicePrefixFormat: (param)=>{
        let { field, min, max } = param;
        return "".concat(field, " must be ").concat(min, "-").concat(max, " letters");
    }
};
